import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogo = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 618,
	height: 140,
	viewBox: "0 0 618 140",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", { d: "M54.9339 136.814C92.4314 136.814 119.242 108.707 119.242 69.9184C119.242 30.3805 92.6189 3.20996 54.9339 3.20996H0V136.814H54.9339ZM50.4342 29.2562C76.495 29.2562 89.8066 46.4955 89.8066 69.9184C89.8066 93.1539 76.12 110.768 50.4342 110.768H28.1232V29.2562H50.4342Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M186.392 140C228.576 140 244.325 113.954 244.325 72.9167V3.20996H215.827V69.169C215.827 106.646 201.766 115.64 186.392 115.64C171.205 115.64 156.956 107.02 156.956 69.169V3.20996H128.458V72.9167C128.458 113.954 144.019 140 186.392 140Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M455.167 136.814V110.768H415.045V3.20996H386.735V136.814H455.167Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M502.389 3.19727H474.079V136.802H502.389V3.19727Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M329.798 109.872L321.663 85.3382L269.53 85.3382L269.848 111.104L329.798 109.872Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M510.57 114.679C524.632 130.42 544.318 139.976 565.879 139.976C594.752 139.976 618 123.861 618 97.8147C618 71.3935 593.814 62.5864 573.753 55.6532C559.692 50.4064 547.88 45.9092 547.88 37.2895C547.88 31.1058 554.442 24.36 566.816 24.36C577.878 24.36 585.752 28.8572 594.752 35.9778L614.625 18.7384C601.314 5.62153 585.377 0 567.379 0C537.568 0 518.07 15.5529 518.07 38.7886C518.07 63.8981 540.943 71.9557 560.629 79.451C575.253 84.6978 588.19 89.9446 588.19 100.438C588.19 109.058 579.003 114.492 567.004 114.492C553.317 114.492 541.88 108.121 531.381 96.503L510.57 114.679Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M311.929 32.4044L277.694 136.814H247.584L295.318 3.20996H328.691L376.613 136.814H346.69L311.929 32.4044Z" })
	]
});
const ForwardRef = forwardRef(SvgLogo);
export default ForwardRef;
